import { Translations } from '../../../localization/translations';

interface Texts {
  headingText: string;
  descriptionText: string;
  buttonText: string;
  secondButtonText?: string;
}

export function getTextsForPremiumUnlockCZ(
  isFeatureEnabled: boolean,
  isUserLoggedIn: boolean,
  unlockedArticlesCount: number,
  translations: Translations,
  lockedForFreeUsers: boolean
): Texts {
  // Case 1: The user is a free user (no subscription), and the content is locked for free users
  if (lockedForFreeUsers) {
    return {
      headingText:
        translations?.premiumBlocker?.unlockArticleReadMoreTitle ||
        'Want to read more? This article is part of Forbes Premium',
      descriptionText:
        translations?.premiumBlocker?.unlockArticleReadMoreDescription ||
        'Get a great reading experience from just 139 CZK per month! No limits and at any time.',
      buttonText: translations?.premiumBlocker?.unlockArticlePremiumButton || 'Buy Subscription',
      secondButtonText: undefined,
    };
  }

  // Case 2: The user is logged in
  if (isUserLoggedIn) {
    if (isFeatureEnabled) {
      // Case 2a: The user has unlocked 3 articles in the last month (limit reached)
      if (unlockedArticlesCount >= 3) {
        return {
          headingText: translations?.premiumBlocker?.unlockArticleLimitedReadMoreTitle || 'Want to read more?',
          descriptionText:
            translations?.premiumBlocker?.unlockArticleLimitedReadMoreDescription ||
            'You have used up your monthly limit of 3 free Premium articles. With a Forbes Premium subscription, you can read them all. No limits and anytime. And from just 139 CZK per month.',
          buttonText: translations?.premiumBlocker?.unlockArticlePremiumButton || 'Buy Subscription',
          secondButtonText: undefined,
        };
      } else {
        // Case 2b: The user has not yet unlocked 3 articles (limit not reached)
        return {
          headingText: `${
            translations?.premiumBlocker?.unlockArticleTitleFirstPart || 'You still have '
          } ${3 - unlockedArticlesCount} ${
            translations?.premiumBlocker?.unlockArticleTitleSecondPart || 'of 3 free Premium articles left'
          }`,
          descriptionText:
            translations?.premiumBlocker?.unlockArticleDescription ||
            'This text is on us! As a registered user you can read 3 Premium articles for free every month.',
          buttonText: translations?.premiumBlocker?.unlockArticleButton || 'Unlock article',
          secondButtonText: translations?.premiumBlocker?.unlockArticlePremiumButton || 'Buy Subscription',
        };
      }
    } else {
      // Case 2c: The free articles feature is disabled, but the user has started to unlock articles.
      if (unlockedArticlesCount < 3 && unlockedArticlesCount > 0) {
        return {
          headingText: `${
            translations?.premiumBlocker?.unlockArticleTitleFirstPart || 'You still have '
          } ${3 - unlockedArticlesCount} ${
            translations?.premiumBlocker?.unlockArticleTitleSecondPart || 'of 3 free Premium articles left'
          }`,
          descriptionText:
            translations?.premiumBlocker?.unlockArticleDescription ||
            'This text is on us! As a registered user you can read 3 Premium articles for free every month.',
          buttonText: translations?.premiumBlocker?.unlockArticleButton || 'Unlock article',
          secondButtonText: translations?.premiumBlocker?.unlockArticlePremiumButton || 'Buy Subscription',
        };
        // Case 2d: The free articles feature is disabled and the user has not started to unlock articles
      } else {
        return {
          headingText:
            translations?.premiumBlocker?.unlockArticleReadMoreTitle ||
            'Want to read more? This article is part of Forbes Premium',
          descriptionText:
            translations?.premiumBlocker?.unlockArticleReadMoreDescription ||
            'Get a great reading experience from just 139 CZK per month! No limits and at any time.',
          buttonText: translations?.premiumBlocker?.unlockArticlePremiumButton || 'Buy Subscription',
          secondButtonText: undefined,
        };
      }
    }
  } else {
    // Case 3: The user is not logged in
    if (isFeatureEnabled) {
      // Case 3a: The free articles feature is enabled
      return {
        headingText:
          translations?.premiumBlocker?.unlockArticleReadMoreTitle ||
          'Want to read more? This article is part of Forbes Premium',
        descriptionText:
          translations?.premiumBlocker?.unlockArticleLogoutDescription ||
          'Sign up and unlock 3 free premium articles, or get a subscription straight away.',
        buttonText: translations?.premiumBlocker?.unlockArticleLoginButton || 'Register / Login',
        secondButtonText: translations?.premiumBlocker?.unlockArticlePremiumButton || 'Buy Subscription',
      };
    } else {
      // Case 3b: The free articles feature is disabled
      return {
        headingText:
          translations?.premiumBlocker?.unlockArticleReadMoreTitle ||
          'Want to read more? This article is part of Forbes Premium',
        descriptionText:
          translations?.premiumBlocker?.unlockArticleReadMoreDescription ||
          'Get a great reading experience from just 139 CZK per month! No limits and at any time.',
        buttonText: translations?.premiumBlocker?.unlockArticleDisabledLoginButton || 'I have a subscription, log in',
        secondButtonText: translations?.premiumBlocker?.unlockArticlePremiumButton || 'Buy Subscription',
      };
    }
  }
}

export function getTextsForPremiumUnlockSK(isUserLoggedIn: boolean, translations: Translations): Texts {
  // Case 1: The user is not logged in
  if (!isUserLoggedIn) {
    return {
      headingText: translations?.premiumBlocker?.unlockArticleReadMoreTitle || 'Continue reading for free',
      descriptionText:
        translations?.premiumBlocker?.unlockArticleReadMoreDescription ||
        'Until the end of February 2025 you can access Premium articles for free, just register and login. Join us in discovering behind the scenes of the business now.',
      buttonText: translations?.premiumBlocker?.unlockArticleLoginButton || 'Log in and unlock',
      secondButtonText: undefined,
    };
  } else {
    // Case 2: The user is logged in
    return {
      headingText:
        translations?.premiumBlocker?.unlockArticleLimitedReadMoreTitle ||
        'The continuation of the article is waiting for you',
      descriptionText:
        translations?.premiumBlocker?.unlockArticleDescription ||
        'This article belongs to the locked content, you are only one click away from reading it.',
      buttonText: translations?.premiumBlocker?.unlockArticleButton || 'Read for free',
      secondButtonText: undefined,
    };
  }
}
